import React from 'react'
import { Tooltip } from '@material-ui/core'

import { getLinkIcon, MASTER_PRODUCT } from '../CommonUpdateCells'

import { NoImagePlaceholder } from '../../../assets'
export const MCImageAssetComponent = (props) => {
  const { value, data } = props
  const thumbURL = (value && value[0] && value[0].thumbURL) || ''

  const activeShop = data && data.shop && data.shop.active
  const deletedShop = data && data.shop && data.shop.deleted
  const orphaned = !data.masterId
  let isParent = !!data.children

  const shouldHide =
    ((!activeShop || deletedShop) && !data.children) ||
    (orphaned && !isParent) ||
    (data.productType && data.productType == 'BUNDLE')
  let linkIcon = getLinkIcon(MASTER_PRODUCT, isParent, data, props.colDef.field)

  const showMcImageModal = (e) => {
    const { data } = props

    if (data) {
      props.openColumnModal && props.openColumnModal('productImages', data.children, data, props)
    }
  }

  const handleIconOption = (event) => {
    if (props.onSyncChildEvent) {
      props.onSyncChildEvent(props, {
        icon: linkIcon.icon,
        title: linkIcon.title,
      })
    }
  }
  return (
    <div className="center-item-column">
      <div
        className="align-item-column-value"
        style={{ overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}
      >
        <img
          style={{ width: '4em' }}
          src={thumbURL}
          onError={(e) => {
            e.target.src = NoImagePlaceholder
          }}
        />
      </div>
      <div style={{ paddingLeft: '10px', float: 'right' }}>
        <span onClick={(e) => showMcImageModal(e)} className="button-to-edit-image">
          Edit
        </span>
      </div>

      <div style={{ float: 'right' }}>
        <Tooltip title={linkIcon.title}>
          <img
            className="icon-validation"
            alt=""
            src={linkIcon.icon}
            hidden={shouldHide}
            onClick={(event) => handleIconOption(event)}
          />
        </Tooltip>
      </div>
    </div>
  )
}

export default MCImageAssetComponent



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Components/MCImageAssetComponent.js